import(/* webpackMode: "eager" */ "/vercel/path0/src/app/pricing/page.jsx");
